<template>
  <div id="search-location">
    <div class="location">
      <router-link v-for="location in locations"
                   :key="location.id"
                   :to="{name: 'location-id-residents', params: {id: location.locationname}}"
                   class="location__link"
      >
        <template v-if="location.status">
          <svg
            id="Group_672"
            data-name="Group 672"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="17.62"
            height="25.172"
            viewBox="0 0 17.62 25.172"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_992"
                  data-name="Rectangle 992"
                  width="17.62"
                  height="25.172"
                  fill="#5f5f5f"
                />
              </clipPath>
            </defs>
            <g id="Group_671"
               data-name="Group 671"
               clip-path="url(#clip-path)"
            >
              <path
                id="Path_289"
                data-name="Path 289"
                d="M8.81,0A8.816,8.816,0,0,0,0,8.81c0,4.374,7.237,14.222,8.842,16.362,1.6-2.139,8.779-12.019,8.779-16.393A8.83,8.83,0,0,0,8.81,0m0,12.9a3.964,3.964,0,1,1,3.964-3.964A3.988,3.988,0,0,1,8.81,12.9"
                fill="#5f5f5f"
              />
            </g>
          </svg>
          <span>
            {{ location.locationname }}
          </span>
        </template>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SearchLocation',
  props: {
    locations: {
      type: Array,
      required: true
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';
.location {
  display: flex;
  padding: 30px 10px;
  @include media-breakpoint-down(xl) {
    display: block;
  }
  &__link {
    color: $c_black;
    text-transform: uppercase;
    @include font-16;
    display: flex;
    align-items: center;
    margin-right: 15px;
    @include media-breakpoint-down(xl) {
      margin-bottom: 10px;
    }
    svg {
      margin-right: 5px;
    }
    &:hover {
      color: $c_base;
      svg path {
        fill: $c_base;
      }
    }
  }
}
</style>
